<template>
  <header id="header" class="header sticky-top">
    <!-- Top Bar -->
    <div class="topbar d-flex align-items-center bg-light py-2 border-bottom">
      <div class="container d-flex justify-content-center justify-content-md-between small text-muted">
        <div class="d-none d-md-flex align-items-center">
          <i class="bi bi-geo-alt me-1"></i>
          Jl. Soekarno-Hatta No. 193 Kendal, Jawa Tengah | Kode Pos 51313
        </div>
        <div class="d-flex align-items-center">
          <i class="bi bi-phone me-1"></i> Telp. (0294) 382900
        </div>
      </div>
    </div>

    <!-- Navbar -->
    <nav class="navbar navbar-expand-lg navbar-light bg-white shadow-sm py-3">
      <!-- MOBILE MENU (OFFCANVAS) -->
      <div class="offcanvas offcanvas-start" tabindex="-1" id="mobileMenu">
        <div class="offcanvas-header">
          <h5 class="offcanvas-title">Menu</h5>
          <button type="button" class="btn-close text-reset" data-bs-dismiss="offcanvas"></button>
        </div>
        <div class="offcanvas-body">
          <ul class="list-group">

            <li v-for="menu in menus" :key="menu.id" class="list-group-item border-0">
              <div class="d-flex justify-content-between align-items-center"
                :class="{ 'cursor-pointer': hasChildren(menu) }"
                @click="hasChildren(menu) ? toggleMobile(menu.id) : closeMobileMenu()">
                <router-link v-if="!hasChildren(menu)" class="text-decoration-none flex-grow-1"
                  :to="menu.url ? `/page/slug/${menu.url}` : '/'" @click="closeMobileMenu">
                  {{ menu.title }}
                </router-link>
                <span v-else class="flex-grow-1">{{ menu.title }}</span>

                <i v-if="hasChildren(menu)"
                  :class="isExpandedMobile(menu.id) ? 'bi bi-chevron-up' : 'bi bi-chevron-down'"></i>
              </div>

              <ul v-if="hasChildren(menu) && isExpandedMobile(menu.id)" class="ps-3 mt-2">
                <li v-for="child in menu.children" :key="child.id" class="mb-2">
                  <div class="d-flex justify-content-between align-items-center"
                    :class="{ 'cursor-pointer': hasChildren(child) }"
                    @click.stop="hasChildren(child) ? toggleMobile(child.id) : closeMobileMenu()">
                    <router-link v-if="!hasChildren(child)" class="text-decoration-none flex-grow-1"
                      :to="child.url ? `/page/slug/${child.url}` : '/'" @click="closeMobileMenu">
                      {{ child.title }}
                    </router-link>
                    <span v-else class="flex-grow-1">{{ child.title }}</span>

                    <i v-if="hasChildren(child)"
                      :class="isExpandedMobile(child.id) ? 'bi bi-chevron-up' : 'bi bi-chevron-down'"></i>
                  </div>

                  <ul v-if="hasChildren(child) && isExpandedMobile(child.id)" class="ps-3 mt-2">
                    <li v-for="grandchild in child.children" :key="grandchild.id" class="mb-2">
                      <div class="d-flex justify-content-between align-items-center"
                        :class="{ 'cursor-pointer': hasChildren(grandchild) }"
                        @click.stop="hasChildren(grandchild) ? toggleMobile(grandchild.id) : closeMobileMenu()">
                        <router-link v-if="!hasChildren(grandchild)" class="text-decoration-none flex-grow-1"
                          :to="grandchild.url ? `/page/slug/${grandchild.url}` : '/'" @click="closeMobileMenu">
                          {{ grandchild.title }}
                        </router-link>
                        <span v-else class="flex-grow-1">{{ grandchild.title }}</span>

                        <i v-if="hasChildren(grandchild)"
                          :class="isExpandedMobile(grandchild.id) ? 'bi bi-chevron-up' : 'bi bi-chevron-down'"></i>
                      </div>

                      <ul v-if="hasChildren(grandchild) && isExpandedMobile(grandchild.id)" class="ps-3 mt-2">
                        <li v-for="greatGrandchild in grandchild.children" :key="greatGrandchild.id" class="mb-2">
                          <router-link class="text-decoration-none" :to="greatGrandchild.url ? `/page/slug/${greatGrandchild.url}` : '/'"
                            @click="closeMobileMenu">
                            {{ greatGrandchild.title }}
                          </router-link>
                        </li>
                      </ul>
                    </li>
                  </ul>
                </li>
              </ul>
            </li>

          </ul>
        </div>
      </div>

      <div class="container">
        <!-- Logo -->
        <router-link to="/" class="navbar-brand d-flex align-items-center">
          <img src="../assets/img/logo/logowarna.png" alt="Logo Kendal" class="me-2" style="height: 50px;" />
        </router-link>

        <!-- Hamburger Button -->
        <button class="navbar-toggler border-0 d-lg-none" type="button" data-bs-toggle="offcanvas"
          data-bs-target="#mobileMenu">
          <i class="bi bi-list fs-1"></i>
        </button>

        <!-- Menu -->
        <div class="collapse navbar-collapse justify-content-end" id="navbarNavDropdown">
          <ul class="navbar-nav">
            <li v-for="menu in menus" :key="menu.id" class="nav-item dropdown position-static"
              @mouseenter="scheduleShow(menu.id)" @mouseleave="scheduleHide(menu.id)">

              <router-link v-if="hasChildren(menu)" class="nav-link dropdown-toggle"
                :to="menu.url ? `/page/slug/${menu.url}` : `/`" role="button" data-bs-toggle="dropdown"
                aria-expanded="false">
                {{ menu.title }}
              </router-link>

              <router-link v-else class="nav-link" :to="menu.url ? `/page/slug/${menu.url}` : `/`">
                {{ menu.title }}
              </router-link>

              <ul v-if="hasChildren(menu)" class="dropdown-menu fade"
                :class="{ show: activeDropdown === menu.id }">
                <li v-for="child in menu.children" :key="child.id"
                  :class="{ 'dropdown-submenu': hasChildren(child) }">
                  <router-link :class="['dropdown-item', { 'dropdown-toggle': hasChildren(child) }]"
                    :to="child.url ? `/page/slug/${child.url}` : `/`">
                    {{ child.title }}
                  </router-link>

                  <ul v-if="hasChildren(child)" class="dropdown-menu">
                    <li v-for="grandchild in child.children" :key="grandchild.id"
                      :class="{ 'dropdown-submenu': hasChildren(grandchild) }">
                      <router-link :class="['dropdown-item', { 'dropdown-toggle': hasChildren(grandchild) }]"
                        :to="grandchild.url ? `/page/slug/${grandchild.url}` : `/`">
                        {{ grandchild.title }}
                      </router-link>

                      <ul v-if="hasChildren(grandchild)" class="dropdown-menu">
                        <li v-for="greatGrandchild in grandchild.children" :key="greatGrandchild.id">
                          <router-link class="dropdown-item"
                            :to="greatGrandchild.url ? `/page/slug/${greatGrandchild.url}` : `/`">
                            {{ greatGrandchild.title }}
                          </router-link>
                        </li>
                      </ul>
                    </li>
                  </ul>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  </header>
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount } from "vue";
import axios from "axios";

// import api from '@/services/api';
import { Offcanvas } from "bootstrap";

const menus = ref([]);
const activeDropdown = ref(null);
const expandedMobile = ref([]);
const hoverTimer = ref(null);

const hasChildren = (item) => item && Array.isArray(item.children) && item.children.length > 0;
const isExpandedMobile = (id) => expandedMobile.value.includes(id);

const scheduleShow = (id) => {
  if (window.innerWidth < 992) return;
  clearTimeout(hoverTimer.value);
  hoverTimer.value = setTimeout(() => {
    activeDropdown.value = id;
  }, 180);
};

const scheduleHide = (id) => {
  if (window.innerWidth < 992) return;
  clearTimeout(hoverTimer.value);
  hoverTimer.value = setTimeout(() => {
    if (activeDropdown.value === id) activeDropdown.value = null;
  }, 220);
};

const toggleMobile = (id) => {
  const index = expandedMobile.value.indexOf(id);
  if (index !== -1) {
    expandedMobile.value.splice(index, 1);
  } else {
    expandedMobile.value.push(id);
  }
};

const closeMobileMenu = () => {
  const offcanvasEl = document.getElementById("mobileMenu");
  const instance = Offcanvas.getInstance(offcanvasEl);
  if (instance) instance.hide();
};

onMounted(async () => {
  try {
    const res = await axios.get("/api/menus");
    menus.value = res.data.data; // pastikan API sudah dalam bentuk tree (parent->children)
  } catch (err) {
    console.log(err);
    console.error("Gagal load menu:", err);
  }
});

// const showDropdown = (id) => {
//   if (window.innerWidth >= 992) activeDropdown.value = id;
// };
// const hideDropdown = () => {
//   if (window.innerWidth >= 992) activeDropdown.value = null;
// };

onBeforeUnmount(() => {
  clearTimeout(hoverTimer.value);
});
</script>

<style scoped>
.header {
  z-index: 1000;
}

.navbar {
  min-height: 70px;
}

.navbar-brand img {
  max-height: 50px;
}

.navbar-nav .nav-item {
  position: relative;
}

.navbar .dropdown-menu {
  margin-top: 0.35rem;
  min-width: 14rem;
  border-radius: 0.75rem;
  border: 1px solid rgba(33, 37, 41, 0.08);
  box-shadow: 0 0.75rem 1.5rem rgba(22, 27, 34, 0.08);
  background: #fff;
  padding: 0.35rem 0;
  transition: opacity 0.18s ease, transform 0.18s ease;
  transform-origin: top center;
}

.navbar .dropdown-item {
  padding: 0.55rem 1rem;
  color: #343a40;
  font-size: 0.95rem;
}

.navbar .dropdown-item:hover,
.navbar .dropdown-item:focus {
  background-color: #f8f9fa;
  color: #212529;
}

.navbar .dropdown-menu.show {
  display: block;
  opacity: 1;
  transform: translateY(0);
}

@media (min-width: 992px) {
  .navbar .dropdown-menu {
    display: none;
    opacity: 0;
    transform: translateY(8px);
  }

  .navbar .nav-item:hover > .dropdown-menu,
  .navbar .dropdown-submenu:hover > .dropdown-menu,
  .navbar .dropdown-submenu:focus-within > .dropdown-menu {
    display: block;
    opacity: 1;
    transform: translateY(0);
  }

  .navbar .dropdown-menu {
    padding: 0.35rem 0;
  }

  .navbar .dropdown-menu .dropdown-submenu > .dropdown-menu {
    margin-top: 0;
  }
}

.dropdown-submenu {
  position: relative;
}

.dropdown-submenu > .dropdown-menu {
  display: none;
  position: absolute;
  top: 0;
  left: 100%;
  margin-left: 0.2rem;
  min-width: 14rem;
  border-radius: 0.75rem;
}

.dropdown-submenu > .dropdown-toggle::after,
.dropdown-submenu > .dropdown-item.dropdown-toggle::after {
  content: "▶";
  float: right;
  margin-left: 0.5rem;
  transform: rotate(0deg);
  transition: transform 0.2s ease;
}

.dropdown-submenu:hover > .dropdown-toggle::after,
.dropdown-submenu:hover > .dropdown-item.dropdown-toggle::after {
  transform: rotate(90deg);
}

.dropdown-menu.fade {
  transition: transform 0.22s ease, opacity 0.22s ease;
  transform: translateY(10px);
  opacity: 0;
}

.dropdown-menu.fade.show {
  transform: translateY(0);
  opacity: 1;
}

.navbar-nav .nav-item,
.navbar-nav .dropdown-menu,
.navbar-nav .nav-link {
  transition: all 0.2s ease;
}

@media (max-width: 991px) {
  .navbar-collapse {
    display: none !important;
  }

  .offcanvas-body {
    padding-top: 0;
  }

  .list-group-item {
    padding-left: 0;
    padding-right: 0;
    border: none;
  }

  .offcanvas-body ul {
    margin: 0;
    padding: 0;
  }

  .offcanvas-body .ps-3 {
    padding-left: 1rem !important;
  }

  .offcanvas-body .dropdown-item,
  .offcanvas-body .text-decoration-none {
    padding-left: 0;
    display: block;
    width: 100%;
  }

  .offcanvas-body .list-group-item .d-flex {
    cursor: pointer;
  }

  .offcanvas-body .mb-2 {
    margin-bottom: 0.5rem;
  }
}

/* Sembunyikan offcanvas di desktop */
@media (min-width: 992px) {
  #mobileMenu {
    display: none !important;
  }
}
</style>
